import GeneralProductInformationStep from './GeneralProductInformationStep.vue'
import { generalProductInformationDescriptor } from './descriptor'
import { createGeneralProductInformationController } from './general-product-information-controller'

const generalProductInformationStepImplementation = Object.freeze({
    descriptor: generalProductInformationDescriptor,
    component: GeneralProductInformationStep,
    createController: createGeneralProductInformationController,
})

export {
    GeneralProductInformationStep,
    createGeneralProductInformationController,
    generalProductInformationDescriptor,
    generalProductInformationStepImplementation,
}
